export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";